import { render } from "./StudyComplianceView.vue?vue&type=template&id=4c5d7289&scoped=true"
import script from "./StudyComplianceView.vue?vue&type=script&lang=js"
export * from "./StudyComplianceView.vue?vue&type=script&lang=js"

import "./StudyComplianceView.vue?vue&type=style&index=0&id=4c5d7289&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5d7289"]])

export default __exports__